
import React, { createContext, useContext } from 'react';
import { GasDashboardContextType } from './types';
import { useDashboardState } from './useDashboardState';

// Create the context with undefined as initial value
const GasDashboardContext = createContext<GasDashboardContextType | undefined>(undefined);

/**
 * Provider component that wraps the application (or part of it)
 * to provide gas dashboard state and functions
 */
export const GasDashboardProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Get all dashboard state and functions from our custom hook
  const dashboardState = useDashboardState();

  return (
    <GasDashboardContext.Provider value={dashboardState}>
      {children}
    </GasDashboardContext.Provider>
  );
};

/**
 * Custom hook to use the gas dashboard context
 * This ensures type safety and proper error handling when the context is used
 */
export const useGasDashboard = () => {
  const context = useContext(GasDashboardContext);
  if (context === undefined) {
    throw new Error('useGasDashboard must be used within a GasDashboardProvider');
  }
  return context;
};

// Re-export types for convenience
export type { KpiCardType } from './types';
